module.exports = __webpack_public_path__ + "a1f7eff9e1ad677c18e7d2b247c0195b.fbx";